<template>
  <div class="page flex-col">
    <!-- 顶部导航与底部统一由全局组件渲染，这里仅呈现主体内容 -->
    <div class="feature-container">
      <h1 class="feature-title">成果特色</h1>

      <section class="feature-section">
        <h2 class="feature-subtitle">（一）理念创新：构建“标准引领、生态共生”的跨境电商教育新范式</h2>
        <p class="feature-paragraph">
          本成果从根本上超越了传统专业教育的封闭模式，首创了以“动态标准为引领、教育-产业生态共生为基石”的人才培养新范式。将人才培养置于开放演进的产业生态中，通过“政行企校”多元协同，将跨境电商国家教学标准、阿里巴巴国际化公司的行业前沿标准、世赛国赛标准进行动态融通与迭代，并内化为跨境电商新质人才培养的核心基因，确保了育人规格与产业演进同频共振。从源头上破解了产教“合而不深”的根本矛盾，实现了教育链、人才链与产业链的有机咬合与价值共生。该范式下，联合企业开发“标准对接”实训包12个，覆盖跨境电商数智化岗位80% 核心技能，1+X 跨境电商B2B数据运营证书通过率达95%。
        </p>
        <figure class="feature-figure">
          <img class="feature-image" src="https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/ts/1.png" alt="跨境电子商务人才培养数智驱动、三链贯通的模块化育人新体系" />
          <figcaption class="feature-caption">图4 跨境电子商务人才培养“数智驱动、三链贯通”的模块化育人新体系</figcaption>
        </figure>
      </section>

      <section class="feature-section">
        <h2 class="feature-subtitle">（二）模式创新：打造“数智驱动、三链贯通”的模块化育人新体系</h2>
        <p class="feature-paragraph">
          系列举措打破了传统的线性培养流程，构建了以数智技术为底层驱动、以“课程链-赛证链-育训链”三链深度贯通为特征的模块化育人新体系。该体系以“素质基础平台+岗位模块+赛证企专项”的课程链实现能力阶梯式跃迁；通过“课赛融通、课证互认”机制，将大赛项目转化为教学模块、证书标准嵌入课程考核，形成以赛促学、以证验技的良性循环；依托产业学院打造“实境实战、培育孵化”实践体系，实施“跟岗-顶岗-创业”三阶育训，打通从学生到创业者的完整能力塑造路径。实现了人才培养从“分段割裂”到“系统闭环、动态适配”的转变，有效解决了岗课赛证“融而不通”与数智赋能“赋而不实”的难题。
        </p>
      </section>

      <section class="feature-section">
        <h2 class="feature-subtitle">（三）机制创新：形成“德技互嵌、价值闭环”的协同育人新机制</h2>
        <p class="feature-paragraph">
          系列举措开创性地构建了“德技互嵌、价值闭环”的长效育人机制。以丝路精神为核心，通过“三德铸魂”与“三匠砺能”的有机融合，将丝路精神、工匠精神、职业伦理等价值塑造如盐入水般融入专业教学、项目实战与竞赛孵化全过程。形成了从课堂认知、岗位锤炼到创业践行的完整价值实现闭环，使学生在解决真实商业问题中自然内化“精益求精、攻坚克难、敢闯会创”的职业精神，弥合了人才素质与产业需求“育而不全”的鸿沟，为培养堪当民族复兴大任的时代新人提供了可复制、可持续的机制保障。
        </p>
        <figure class="feature-figure">
          <img class="feature-image" src="https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/ts/2.png" alt="跨境电子商务人才培养德技互嵌、价值闭环的协同育人新机制" />
          <figcaption class="feature-caption">图5 跨境电子商务人才培养“德技互嵌、价值闭环”的协同育人新机制</figcaption>
        </figure>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanhuChengguoTese'
};
</script>

<style scoped>
/* 页面主容器：统一宽度与居中 */
.feature-container { max-width: 1080px; margin: 36px auto; padding: 0 16px; }
.feature-title { font-size: 24px; font-weight: 700; color: #222; text-align: center; margin-bottom: 24px; }

/* 小节排版 */
.feature-section { margin-bottom: 28px; }
.feature-subtitle { font-size: 18px; font-weight: 600; color: #215195; margin-bottom: 12px; }
.feature-paragraph { font-size: 16px; line-height: 1.9; color: #333; text-align: justify; }

/* 图片与图注 */
.feature-figure { margin: 14px 0 8px; }
.feature-image { max-width: 100%; height: auto; border-radius: 6px; box-shadow: 0 6px 18px rgba(0,0,0,0.08); }
.feature-caption { font-size: 14px; color: #666; text-align: center; margin-top: 8px; }

/* 响应式优化 */
@media (max-width: 768px) {
  .feature-title { font-size: 22px; }
  .feature-subtitle { font-size: 17px; }
  .feature-paragraph { font-size: 15px; }
}
</style>